import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AudienceApiService, AudienceTargetInfo } from '../../../../services/audience-api.service';

/**
 * Tags tab of the advanced "Additional Info" card. Rebuilt from admin-dashboard
 * `audience-insights-composition`: the audience's target tags + target size (the global "common tags"
 * highlighting from the old view is intentionally dropped for now).
 */
@Component({
  selector: 'app-audience-tags-tab',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './audience-tags-tab.component.html',
  styleUrls: ['./audience-tags-tab.component.scss']
})
export class AudienceTagsTabComponent implements OnChanges {
  @Input() audienceId: string | null = null;

  tags: string[] = [];
  targetSize: number | null = null;
  loading = false;
  error = false;

  private loadedFor: string | null = null;

  constructor(private audienceApi: AudienceApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['audienceId'] && this.audienceId && this.audienceId !== this.loadedFor) {
      this.load(this.audienceId);
    }
  }

  private load(audienceId: string): void {
    this.loadedFor = audienceId;
    this.loading = true;
    this.error = false;
    this.tags = [];
    this.targetSize = null;
    this.audienceApi.getAudienceTargetInfo(audienceId).subscribe({
      next: (info: AudienceTargetInfo | null) => {
        if (this.loadedFor !== audienceId) {
          return;
        }
        this.tags = info?.Tags ?? [];
        this.targetSize = info?.TargetSize != null ? Number(info.TargetSize) : null;
        this.loading = false;
      },
      error: () => {
        if (this.loadedFor !== audienceId) {
          return;
        }
        this.error = true;
        this.loading = false;
      }
    });
  }

  get hasData(): boolean {
    return this.tags.length > 0 || this.targetSize != null;
  }

  formatNumber(value: number): string {
    return value.toLocaleString('it-IT');
  }
}
